import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Hp from './pages/Hp';
import VybaveniDomu from './pages/VybaveniDomu';
import PudorisDomu from './pages/PudorisDomu';
import SpecifikaceStavby from './pages/SpecifikaceStavby';
import Galerie from './pages/Galerie';
import Kontakt from './pages/Kontakt';
import Cookies from './pages/Cookies';
import Gdpr from './pages/Gdpr';
import Error from './pages/error';
import SharedLayout from './pages/SharedLayout';
import Catalogue from './pages/catalogue';
import Dum2kk from './pages/Dum2kk';
import Dum3kk from './pages/Dum3kk';
import Dum4kk from './pages/Dum4kk';


function App() {
  return (
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<SharedLayout/>}>
            <Route index element={<Hp/>}/>
            <Route path="/vybaveni-domu" element={<VybaveniDomu/>}/>
            <Route path="/pudorys-domu" element={<PudorisDomu/>}/>
            <Route path="/specifikace-stavby" element={<SpecifikaceStavby/>}/>
            <Route path="/galerie" element={<Galerie/>}/>
            <Route path="/kontakt" element={<Kontakt/>}/>
            <Route path="/cookies" element={<Cookies/>}/>
            <Route path="/gdpr" element={<Gdpr/>}/>
            <Route path="*" element={<Error/>}/>
            <Route path="/katalog-domu" element={<Catalogue/>}/>
            <Route path="/dum-2kk" element={<Dum2kk/>}/>
            <Route path="/dum-3kk" element={<Dum3kk/>}/>
            <Route path="/dum-4kk" element={<Dum4kk/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
